import { useLayoutEffect, useState } from 'react';
import { Pane, Tablist, Tab } from 'evergreen-ui';
import { useLocation } from 'react-router-dom';
import MainLayout from '../MainLayout';
import FeedbackBox from './FeedbackBox';
import AccountTab from './AccountTab';
import CreateNftTab from './CreateNftTab';
import NftListTab from './NftListTab';
import Drop from './DropTab'; 
import RewardsTab from './RewardsTab';
import TokenTab from './TokenTab';
import SwapTab from './SwapTab';

const tabs = ['Compte', 'Publier un NFT', "Mes NFT", "Publier un Drop", "Gestion des récompenses", "Gestion du Token", "Swap Tokens"];

const Dashboard: React.FC = () => {
  const [selectedIndex, setTabSelectedIndex] = useState(0);
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
  }, [pathname]);

  return (
    <MainLayout>
      <FeedbackBox setTabSelectedIndex={setTabSelectedIndex} />
      <Pane>
        <Tablist marginBottom={20} marginTop={50}>
          {tabs.map((tab, index) => (
            <Tab
              key={tab}
              id={tab}
              appearance="primary"
              onSelect={() => setTabSelectedIndex(index)}
              isSelected={index === selectedIndex}
              className="no-focus"
            >
              {tab}
            </Tab>
          ))}
        </Tablist>
        <Pane flex="1">
          {selectedIndex === 0 && <AccountTab />}
          {selectedIndex === 1 && <CreateNftTab />}
          {selectedIndex === 2 && <NftListTab />}
          {selectedIndex === 3 && <Drop />}
          {selectedIndex === 4 && <RewardsTab/>}
          {selectedIndex === 5 && <TokenTab />}
          {selectedIndex === 6 && <SwapTab />}
        </Pane>
      </Pane>
    </MainLayout>
  );
};

export default Dashboard;
